import { combineReducers } from 'redux'
import { reducer as auth } from './auth';
import { reducer as agendaFilters } from './agendaFilters';
import { reducer as brewery } from './brewery';
import { reducer as breweries } from './breweries';
import { reducer as productFilters } from './productFilters';

export const rootReducer = combineReducers({
  auth,
  agendaFilters,
  brewery,
  breweries,
  productFilters
})



// WEBPACK FOOTER //
// ./src/redux/index.js